import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable } from 'rxjs';
import { ExtendSessionDialogComponent } from '../../dialogs/extend-session-dialog/extend-session-dialog.component';
import { AuthorizationDialogComponent } from '../../dialogs/authorization-dialog/authorization-dialog.component';
import { ErrorResolutionDialogComponent } from '../../dialogs/error-resolution-dialog/error-resolution-dialog.component';

/**
 * Dialog service handles opening all dialogs in the application. All dialog openings
 * return an observable on completion
 */
@Injectable({
  providedIn: 'root'
})
export class DialogService {
  /**
   * Default constructor for the dialog service
   *
   * @param dialog
   */
  constructor(
    public dialog: MatDialog,
  ) { }

  /**
   * Open up the extend session dialog in the middle of the screen
   */
  public openExtendSession(): Observable<any> {
    // Open the dialog
    const dialogRef = this.dialog.open(ExtendSessionDialogComponent, {
      // width: "30vw",
      // height: "50vh",
    });

    return dialogRef.afterClosed();
  }

  /**
   * Open up the authorization dialog using the dialog service
   */
  public openAuthorizationDialog(): Observable<any> {
    // Open the dialog
    const dialogRef = this.dialog.open(AuthorizationDialogComponent, {
      width: '70vw',
      height: '90vh',
    });

    return dialogRef.afterClosed();
  }

  /**
   * Open up the error resolution dialog
   */
  public openErrorResolutionDisclosure(): Observable<any> {
    // Open the dialog
    const dialogRef = this.dialog.open(ErrorResolutionDialogComponent, {
      width: '70vw',
      height: '90vh',
    });

    return dialogRef.afterClosed();
  }
}